/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react'

import {
  BooleanFieldData,
  InventoryChannelType,
  InventoryRateplanType,
  NumberFieldData
} from '../../../mockData/inventory'
import {
  ChannelRatePlanDetailsForEachDate,
  MenuItemInInventory,
  PriceAndOccupancy,
  RatePlanDetailsForEachDate
} from '../../../types/inventory'
import RenderCheckboxRowCell from './RenderCheckboxRowCell'
import RenderInputRowCell from './RenderInputRowCell'

interface RenderRowValuesProps {
  selectedInventoryField?: MenuItemInInventory
  // rowData?: InventoryRateplanType | InventoryChannelType
  rowData?: RatePlanDetailsForEachDate[]
  weekendIndexes: number[]
  onSaveRowData?: (
    rowData: InventoryRateplanType | InventoryChannelType
  ) => void
  maxValues?: NumberFieldData[]
  occupancy: number | 'def'
  hideZeroes: boolean
  defaultOccupancy: number
}

const RenderRowValues: React.FC<RenderRowValuesProps> = ({
  selectedInventoryField,
  rowData,
  weekendIndexes,
  hideZeroes,
  defaultOccupancy,
  onSaveRowData,
  maxValues,
  occupancy
}) => {
  const [hoveredItem, sethoveredItem] = useState<number | null>(null)
  const occupancyToCompare = occupancy === 'def' ? defaultOccupancy : occupancy
  // const handleSaveRowData = (
  //   newValue: number | boolean,
  //   date: string,
  //   index: number,
  //   editedValue?: string
  // ) => {
  //   if (selectedInventoryField === 'channels') {
  //     return
  //   }
  //   if (selectedInventoryField === 'allocatedAvail') {
  //     const newRowData = rowData as InventoryChannelType
  //     const newValueForChangedRow = newRowData[
  //       selectedInventoryField
  //     ] as NumberFieldData[]
  //     newValueForChangedRow[firstDayIndexInInventory + index] = {
  //       date,
  //       value: newValue as number,
  //       edited: true
  //     }
  //     onSaveRowData({
  //       ...newRowData,
  //       [selectedInventoryField]: newValueForChangedRow
  //     })
  //   } else {
  //     const newValueForChangedRow = rowData[selectedInventoryField] as
  //       | NumberFieldData[]
  //       | BooleanFieldData[]
  //     newValueForChangedRow[firstDayIndexInInventory + index] = {
  //       date,
  //       value: newValue,
  //       edited: true,
  //       editedValue
  //     }
  //     onSaveRowData({
  //       ...rowData,
  //       [selectedInventoryField]: newValueForChangedRow
  //     })
  //   }
  // }

  switch (selectedInventoryField?.code) {
    case 'price':
      return (
        <>
          {rowData?.map(
            (cellData: RatePlanDetailsForEachDate, index: number) => (
              <RenderInputRowCell
                key={cellData.price.toString() + index.toString()}
                {...{
                  hoveredItem,
                  sethoveredItem,
                  value: hideZeroes
                    ? parseInt(
                        cellData.price
                          .find(
                            (value: PriceAndOccupancy) =>
                              value.occupancy === occupancyToCompare
                          )
                          ?.price.value.toString()
                          .slice(0, -4) || '0'
                      ) || 0
                    : cellData.price.find(
                        (value: PriceAndOccupancy) =>
                          value.occupancy === occupancyToCompare
                      )?.price.value || 0,
                  edited: cellData.price.find(
                    (value: PriceAndOccupancy) =>
                      value.occupancy === occupancyToCompare
                  )?.price.manual,
                  index,
                  weekendIndexes
                }}
                isPriceType
                // onSaveValue={(newValue, editedValue) =>
                //   handleSaveRowData(newValue, cellData.date, index, editedValue)
                // }
              />
            )
          )}
        </>
      )
    case 'discountPercentage':
      return (
        <>
          {rowData?.map(
            (cellData: RatePlanDetailsForEachDate, index: number) => (
              <RenderInputRowCell
                {...{
                  hoveredItem,
                  sethoveredItem,
                  value:
                    parseFloat(
                      cellData.price
                        .find(
                          (value: PriceAndOccupancy) =>
                            value.occupancy === occupancyToCompare
                        )
                        ?.discountPercent.toFixed(2) || '0.00'
                    ) || 0,
                  edited: cellData.price.find(
                    (value: PriceAndOccupancy) =>
                      value.occupancy === occupancyToCompare
                  )?.price.manual,
                  index,
                  weekendIndexes
                }}
                isPriceType
                // onSaveValue={(newValue, editedValue) =>
                //   handleSaveRowData(newValue, cellData.date, index, editedValue)
                // }
              />
            )
          )}
        </>
      )

    case 'availability':
      return (
        <>
          {(rowData as ChannelRatePlanDetailsForEachDate[] | undefined)?.map(
            (cellData: ChannelRatePlanDetailsForEachDate, index: number) => (
              <RenderInputRowCell
                key={cellData.availability.toString() + index.toString()}
                {...{
                  hoveredItem,
                  sethoveredItem,
                  value: cellData.availability.value,
                  edited: cellData.availability.manual,
                  index,
                  weekendIndexes
                }}
                isPriceType
                // onSaveValue={(newValue, editedValue) =>
                //   handleSaveRowData(newValue, cellData.date, index, editedValue)
                // }
              />
            )
          )}
        </>
      )
    case 'pooledAvailability':
      return (
        <>
          {(rowData as ChannelRatePlanDetailsForEachDate[] | undefined)?.map(
            (cellData: ChannelRatePlanDetailsForEachDate, index: number) => (
              <RenderInputRowCell
                key={cellData.pooledAvailability.toString() + index.toString()}
                {...{
                  hoveredItem,
                  sethoveredItem,
                  value: cellData.pooledAvailability.value,
                  edited: cellData.pooledAvailability.manual,
                  index,
                  weekendIndexes
                }}
                isPriceType
                // onSaveValue={(newValue, editedValue) =>
                //   handleSaveRowData(newValue, cellData.date, index, editedValue)
                // }
              />
            )
          )}
        </>
      )
    case 'allocatedAvailability':
      return (
        <>
          {(rowData as ChannelRatePlanDetailsForEachDate[] | undefined)?.map(
            (cellData: ChannelRatePlanDetailsForEachDate, index: number) => (
              <RenderInputRowCell
                key={
                  cellData.allocatedAvailability.toString() + index.toString()
                }
                {...{
                  hoveredItem,
                  sethoveredItem,
                  value: cellData.allocatedAvailability.value,
                  edited: cellData.allocatedAvailability.manual,
                  index,
                  weekendIndexes
                }}
                isPriceType
                // onSaveValue={(newValue, editedValue) =>
                //   handleSaveRowData(newValue, cellData.date, index, editedValue)
                // }
              />
            )
          )}
        </>
      )
    case 'minStay':
      return (
        <>
          {rowData?.map(
            (cellData: RatePlanDetailsForEachDate, index: number) => (
              <RenderInputRowCell
                key={cellData.minStay.toString() + index.toString()}
                {...{
                  hoveredItem,
                  sethoveredItem,
                  value: cellData.minStay.value,
                  index,
                  edited: cellData.minStay.manual,
                  weekendIndexes
                }}
                // onSaveValue={(newValue) =>
                //   handleSaveRowData(newValue, cellData.date, index)
                // }
              />
            )
          )}
        </>
      )
    case 'maxStay':
      return (
        <>
          {rowData?.map(
            (cellData: RatePlanDetailsForEachDate, index: number) => (
              <RenderInputRowCell
                key={cellData.maxStay.toString() + index.toString()}
                {...{
                  hoveredItem,
                  sethoveredItem,
                  value: cellData.maxStay.value,
                  index,
                  edited: cellData.maxStay.manual,
                  weekendIndexes
                }}
                // onSaveValue={(newValue) =>
                //   handleSaveRowData(newValue, cellData.date, index)
                // }
              />
            )
          )}
        </>
      )
    case 'closed':
      return (
        <>
          {rowData?.map(
            (cellData: RatePlanDetailsForEachDate, index: number) => (
              <RenderCheckboxRowCell
                key={cellData.closed.toString() + index.toString()}
                {...{
                  hoveredItem,
                  sethoveredItem,
                  value: cellData.closed.value,
                  index,
                  edited: cellData.closed.manual,
                  weekendIndexes
                }}
                // onSaveValue={(newValue) =>
                //   handleSaveRowData(newValue, cellData.date, index)
                // }
              />
            )
          )}
        </>
      )
    case 'cta':
      return (
        <>
          {rowData?.map(
            (cellData: RatePlanDetailsForEachDate, index: number) => (
              <RenderCheckboxRowCell
                key={cellData.cta.toString() + index.toString()}
                {...{
                  hoveredItem,
                  sethoveredItem,
                  value: cellData.cta.value,
                  index,
                  edited: cellData.cta.manual,
                  weekendIndexes
                }}
                // onSaveValue={(newValue) =>
                //   handleSaveRowData(newValue, cellData.date, index)
                // }
              />
            )
          )}
        </>
      )
    case 'ctd':
      return (
        <>
          {rowData?.map(
            (cellData: RatePlanDetailsForEachDate, index: number) => (
              <RenderCheckboxRowCell
                key={cellData.ctd.toString() + index.toString()}
                {...{
                  hoveredItem,
                  sethoveredItem,
                  value: cellData.ctd.value,
                  index,
                  edited: cellData.ctd.manual,
                  weekendIndexes
                }}
                // onSaveValue={(newValue) =>
                //   handleSaveRowData(newValue, cellData.date, index)
                // }
              />
            )
          )}
        </>
      )
    default:
      return (
        <>
          {rowData?.map(
            (cellData: RatePlanDetailsForEachDate, index: number) => (
              <RenderInputRowCell
                key={
                  cellData.addOns
                    .find(
                      (addon) => addon.code === selectedInventoryField?.code
                    )
                    ?.code.toString() + index.toString()
                }
                {...{
                  hoveredItem,
                  sethoveredItem,
                  value: hideZeroes
                    ? parseInt(
                        cellData.addOns
                          .find(
                            (addon) =>
                              addon.code === selectedInventoryField?.code
                          )
                          ?.amount.value.toString()
                          .slice(0, -4) || '0'
                      )
                    : cellData.addOns.find(
                        (addon) => addon.code === selectedInventoryField?.code
                      )?.amount.value || 0,
                  edited: cellData.addOns.find(
                    (addon) => addon.code === selectedInventoryField?.code
                  )?.amount.manual,
                  index,
                  weekendIndexes
                }}
                isPriceType
                // onSaveValue={(newValue, editedValue) =>
                //   handleSaveRowData(newValue, cellData.date, index, editedValue)
                // }
              />
            )
          )}
        </>
      )
  }
}

export default RenderRowValues
